import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withSnackbar } from 'notistack';

import { setAlertActionCreator } from 'plugins/store/reducers/common.reducer';
import Button from 'components/CustomButtons/Button';
import SnackMessage from 'components/Snackbar/SnackMessage';
import { withStyles } from '@material-ui/core/styles';

const styles = {
	input: {
		display: 'none',
	},
	confirmDialog: {
		textAlign: 'center',
	},
};

const confirmMessage = (fileName) => <div>Upload file: <b>{fileName}</b>?</div>

const fileTypeInvalidError = 'Unable to upload file. File type must be .csv';

class CsvUpload extends React.Component {
	allowedFormats = '.csv';

	fileInput = React.createRef();

	showErorMessages = () => {
		this.props.enqueueSnackbar([fileTypeInvalidError], {
			content: (key, message) => <SnackMessage id={key} message={message} color='danger' />,
		});
	};

	openConfirmDialog = (file) => {
		this.props.setAlert({
			type: 'warning',
			title: this.props.dialogTitle || 'Upload CSV List',
			children: confirmMessage(file.name),
			confirmBtnText: 'Upload',
			cancelBtnText: 'Cancel',
			confirmBtnColor: 'success',
			onConfirm: () => {
				if (this.props.onLoad) {
					this.props.onLoad(file);
				}
				this.props.setAlert(null);
			},
			onCancel: () => this.props.setAlert(null),
		});
	}

	validationCsv = (name) => name.slice(-4) === '.csv';

	openFileInput = () => {
		this.fileInput.current.click();
	};

	onFileLoad = (event) => {
		event.preventDefault();
		const file = event.target.files[0];

		if (this.validationCsv(file.name)) {
			this.openConfirmDialog(file);
		} else {
			this.showErorMessages();
		}
		this.fileInput.current.value = null;
	}

	render() {
		const { classes, label } = this.props;
		return (<>
			<Button
				size="sm"
				color="warning"
				onClick={this.openFileInput}
				className={classes.button}
			>
				{label || 'Upload csv list'}
			</Button>
			<input
				className={classes.input}
				type="file"
				accept={this.allowedFormats}
				onChange={this.onFileLoad}
				ref={this.fileInput} />
		</>);
	}
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
	setAlert: (dialog) => dispatch(setAlertActionCreator(dialog)),
});

export default compose(
	withSnackbar,
	connect(mapStateToProps, mapDispatchToProps),
	withStyles(styles),
)(CsvUpload);
